export type NotificationContactRequestBody = {
  contactRequest: {
    email: string
    message: string
  }
}

export const sendTomboHomePageMessage = (params: NotificationContactRequestBody) => {
  return fetch("/api/notifications", {
    method: "POST",
    body: JSON.stringify(params),
  })
}
